import { EncartMiseEnAvant } from '@components/encart-mise-en-avant/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const encartMiseEnAvantMock: Block<EncartMiseEnAvant> = {
  type: 'encart-mise-en-avant',
  data: {
    title: {
      text: `Une cuisine de folie et un devis en 1 seul RDV avec Coo'ki`,
      as: 'h2',
    },
    items: [
      {
        title: `1 - On prend un café`,
        text: `et vous dites tout à nos kitcheners`,
        image: imageMock,
      },
      {
        title: `2 - On se lâche`,
        text: `avec pour seule limite votre imagination`,
        image: imageMock,
      },
      {
        title: `3 - Mais pas sur le prix`,
        text: `vous gardez le contrôle sur votre budget`,
        image: imageMock,
      },
    ],
    text: `Venez jouer avec notre outil de création en magasin !`,
    cta: {
      label: `Je prends rendez-vous`,
      url: '/mock-prendre-un-rdv',
    },
    gtmConfigCta: {
      event: 'click_cta_rdv_{{value}}',
      group: 'rdv',
      description: 'bloc rdv {{page}}',
      context: 'clic vers tunnel rdv',
    },
  },
};
